'use client';

import { ReactNode, Ref, forwardRef, useEffect, useRef, useState } from "react";
import { Swiper as SwiperJS, SwiperProps, SwiperSlideProps } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { twMerge } from 'tailwind-merge';
import { createPortal } from 'react-dom';
import Close from './svg/Close';

interface Props {
  title?: string;
  close: Function;
  children: JSX.Element | JSX.Element[];
  className?: string;
}

const Modal = ({ children,close,title, className }: Props) => {

  
  const ref = useRef<any>();

const handleClick = (e: MouseEvent) => {
  if (ref.current && !ref.current.contains(e.target as Node)) {
    close();
  }
};

  useEffect(() => {
    window.addEventListener('mousedown',handleClick);
    return () => {
      window.removeEventListener('mousedown',handleClick);
    }
  },[]);

  return (
    createPortal(
   <div className='fixed top-0 left-0 h-full w-full z-[1000000] bg-black  bg-opacity-70 grid place-items-center'>
      <div ref={ref} className={twMerge('flex flex-col gap-[24px] p-[24px] pt-[36px] relative bg-white dark:bg-tertiary tablet:rounded-[16px] h-full tablet:h-fit w-full', className)}>
        <div className='grid place-items-center cursor-pointer absolute top-[24px] right-[24px]' onClick={() => close()}>
          <Close className='[&>*]:fill-dark dark:[&>*]:fill-white !h-[16px] !w-[16px]'/>
        </div>
        {children}
      </div>

   </div>, document.body)
)
}


export default Modal;